import GenericDoughnutChart from './GenericDoughnutChart';

const DoughnutChart = ({ claimed, unclaimed, requested }) => {
  const labels = ['Claimed', 'Unclaimed', 'Requested'];
  const data = [+claimed, +unclaimed, +requested];
  const backgroundColors = ['#36A2EB', '#BE3144', '#FFCE56'];

  const tooltipCallback = (tooltipItem) => {
    return `${tooltipItem.label}: $${tooltipItem.raw}`;
  };

  return (
    <GenericDoughnutChart
      labels={labels}
      data={data}
      backgroundColors={backgroundColors}
      tooltipCallback={tooltipCallback}
    />
  );
};

export default DoughnutChart;
